import Text from "@/app/(site)/_components/Atoms/Text"
import React from "react"

export interface BadgeProps {
    badge: string
}

export const Badge: React.FC<BadgeProps> = ({ badge }: BadgeProps) => {
    const classes = `flex px-8 py-6 md:px-6 md:py-6 2xl:px-8 2xl:py-8 bg-black`
    return (
        <div className={classes}>
            <Text
                weight="regular"
                size="large"
                className="text-[10px] text-white md:text-[12px] xl:text-[16px]"
            >
                {badge}
            </Text>
        </div>
    )
}
